var _ = require('underscore');
var qs = require('querystring');

var Preferences = function Preferences(props, details, disabled) {
    this.featureManager = details && details.featureManager;
    this.audienceSettings = !disabled && props.audienceSettings || Preferences.defaultAudiencePreferences;
};

Preferences.defaultAudiencePreferences = {
    all: true,
    juvenile: false,
    youngadult: false,
    generalcontent: false,
    adultonly: false
};

Preferences.prototype.isSafeItem = function (item) {
    if (this.audienceSettings.all) {
        return true;
    }
    var itemMaturityLevels = _.object(_.pluck(item, 'id'), _.pluck(item, 'isApplied'));
    return _.isMatch(this.audienceSettings, itemMaturityLevels);
};

Preferences.prototype.getAppropriateAudienceList = function(audienceList) {
    var audienceListArray = _.isArray(audienceList) ? audienceList : [audienceList];
    if (this.audienceSettings.all) {
        return audienceListArray;
    }
    return audienceListArray.filter(item => this.audienceSettings[item]);
};

Preferences.prototype.getAudienceSettingsArray = function () {
    return _.keys(_.pick(this.audienceSettings, val => !!val));
};

Preferences.prototype.getAudienceRestrictions = function() {
    var audienceRestrictions = [];
    if (this.audienceSettings.juvenile) {
        audienceRestrictions.push('juvenile');
    }
    if (this.audienceSettings.youngadult) {
        audienceRestrictions.push('young adult');
    }
    if (this.audienceSettings.generalcontent) {
        audienceRestrictions.push('general adult');
    }
    if (this.audienceSettings.adultonly) {
        audienceRestrictions.push('mature adult');
    }
    return audienceRestrictions;
};

Preferences.prototype.getMaturityQueryString = function () {
    if (!this.audienceSettings.all) {
        var array = this.getAudienceSettingsArray();
        return '?' + qs.stringify({maturityLevel: array});
    }
    return '?';
};

Preferences.parseReq = function(req) {
    return Preferences.parseProfile(req && req.profile);
};

Preferences.parseProfile = function(profile) {
    return {
        audienceSettings: profile && profile.settings && profile.settings['audience-setting']
    };
};

module.exports = Preferences;
